import React from "react";
import unauthorizedImg from "../assets/unauthorized.png"; // add your image

const Unauthorized = () => (
  <div style={{ textAlign: "center", marginTop: "10rem" }}>
    <img src={unauthorizedImg} alt="Unauthorized" style={{ maxWidth: "400px" }} />
  </div>
);

export default Unauthorized;
